module.exports = __webpack_public_path__ + "static/media/GoogleLogo.835e0d35.png";